@if (product$ | async; as product) {
<div class="section pdp-tab">
  <div class="d-none d-md-block">
    <ul ngbNav #nav="ngbNav" class="nav-tabs w-100" [(activeId)]="active" tabindex="-1">
      <li [ngbNavItem]="'DESCRIPTION'" data-testing-id="product-description-tab" role="presentation">
        <a ngbNavLink>{{ 'product.description.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <div [ishServerHtml]="product.longDescription"></div>
        </ng-template>
      </li>
      @if (product.attributeGroups?.PDPTabs) { @for (tab of generateProductTabs(product.attributeGroups['PDPTabs']) |
      keyvalue : originalOrder; track tab) {
      <li [ngbNavItem]="tab.key" data-testing-id="product-description-tab" role="presentation">
        <a ngbNavLink>{{ tab.key }}</a>
        <ng-template ngbNavContent>
          <div [ishServerHtml]="tab.value"></div>
        </ng-template>
      </li>
      } } @if (product.attributes?.length) {
      <li [ngbNavItem]="'DETAILS'" role="presentation">
        <a ngbNavLink>{{ 'product.details.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <ish-product-attributes [product]="product" />
        </ng-template>
      </li>
      } @if (product.attachments?.length) {
      <li [ngbNavItem]="'ATTACHMENTS'" role="presentation">
        <a ngbNavLink>{{ 'product.attachments.heading' | translate }}</a>
        <ng-template ngbNavContent>
          <ish-product-attachments />
        </ng-template>
      </li>
      } @if ((isVariationMaster$ | async) === false) {
      <li *ishFeature="'rating'" [ngbNavItem]="'REVIEWS'" role="presentation">
        <a ngbNavLink>{{ 'product.reviews.heading' | translate }} ({{ product.numberOfReviews }})</a>
        <ng-template ngbNavContent>
          <ish-lazy-product-reviews />
        </ng-template>
      </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
  <!-- Mobile Accordion View -->
  <div class="product-accordion d-block d-md-none">
    <ish-accordion>
      <ish-accordion-item [isCollapsed]="true" heading="{{ 'product.description.heading' | translate }}">
        <div class="p-4">
          <div>
            <div [ishServerHtml]="product.longDescription"></div>
          </div>
        </div>
      </ish-accordion-item>
      @if (product.attributeGroups?.PDPTabs) {
      <div>
        @for (tab of generateProductTabs(product.attributeGroups['PDPTabs']) | keyvalue : originalOrder; track tab) {
        <ish-accordion-item data-testing-id="product-description-tab" heading="{{ tab.key }}">
          <div>
            <div [ishServerHtml]="tab.value"></div>
          </div>
        </ish-accordion-item>
        }
      </div>
      } @if (product.attributes?.length) {
      <div>
        <ish-accordion-item heading="{{ 'product.details.heading' | translate }}">
          <div class="p-4">
            <ish-product-attributes [product]="product" />
          </div>
        </ish-accordion-item>
      </div>
      } @if (product.attachments?.length) {
      <div>
        <ish-accordion-item heading="{{ 'product.attachments.heading' | translate }}">
          <div class="p-4">
            <ish-product-attachments />
          </div>
        </ish-accordion-item>
      </div>
      }
      <div *ishFeature="'rating'">
        <ish-accordion-item heading="{{ 'product.reviews.heading' | translate }} ({{ product.numberOfReviews }})">
          <div class="p-4">
            <ish-lazy-product-reviews />
          </div>
        </ish-accordion-item>
      </div>
    </ish-accordion>
  </div>
</div>
}
